import IMenuItem from "@/interfaces/Props/IMenuItem";
import { selectMenu } from "@/redux/features/Setting/Menu/menuSlice";
import { useAppSelector } from "@/redux/hooks";
import { Box, List, Stack, SvgIcon, Typography } from "@mui/material";
import NavItem from "./NavItem";
import Label from "@/components/Label/Label";

const NavGroup = ({ items }: { items: IMenuItem }) => {
  const menu = useAppSelector(selectMenu);

  const { drawerOpen } = menu;

  const navCollapse = items.children?.map((item) => {
    switch (item.type) {
      case "collapse":
        return (
          <Typography
            key={item.id}
            variant="caption"
            color="error"
            sx={{ p: 2.5 }}
          >
            collapse - only available in paid version
          </Typography>
        );
      case "item":
        return <NavItem key={item.id} item={item} level={1} />;

      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        items.title &&
        drawerOpen && (
          <Box
            display="flex"
            sx={{ pl: 2, justifyContent: "left", alignItems: "center" }}
          >
            <Stack direction="row" spacing={2}>
              <SvgIcon sx={{ color: "primary.contrastText" }} fontSize="small">
                {" "}
                {items.icon}{" "}
              </SvgIcon>
              <Label
                id={items.title}
                variant="subtitle1"
                color="primary.contrastText"
              />
            </Stack>

            {/* only available in paid version */}
          </Box>
        )
      }
      sx={{ mb: drawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
};

export default NavGroup;
